/** @format */

import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import { FormikProps } from "formik";
import { MeansTestDto } from "../../features/admin/models";
import { ErrorBox } from "../custom/ErrorBox";

interface Props {
  formik: FormikProps<any>;
  guardians: MeansTestDto[];
}
export default function GuardianDropdown({ formik, guardians }: Props) {
  return (
    <>
      {guardians && (
        <>
          <FormControl fullWidth size="small">
            <InputLabel
              error={
                formik.touched.identityNumber &&
                Boolean(formik.errors.identityNumber)
              }
              id="demo-select-small"
            >
              Select Guardian
            </InputLabel>
            <Select
              name="identityNumber"
              labelId="demo-select-small"
              id="demo-select-small-identityNumber"
              value={formik.values.identityNumber}
              label="Select Guardian"
              onBlur={formik.handleBlur}
              onChange={(e: SelectChangeEvent<any>) => {
                formik.setFieldValue("identityNumber", e.target.value);

                const findGuardian = guardians.find(
                  (s) => s.identityNumber === e.target.value
                );

                if (findGuardian) {
                  formik.setFieldValue("fullName", findGuardian.fullName);
                }
              }}
              error={
                formik.touched.identityNumber &&
                Boolean(formik.errors.identityNumber)
              }
            >
              <MenuItem value={0} disabled>
                Select Guardian
              </MenuItem>
              {guardians.map((item: MeansTestDto, key: number) => {
                return (
                  <MenuItem key={key} value={item.identityNumber}>
                    {item.fullName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>

           <ErrorBox>
           {formik.touched.identityNumber &&
              Boolean(formik.errors.identityNumber)}
                                                  </ErrorBox>

        </>
      )}
    </>
  );
}
